import React from 'react';

function ReadCv(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6356 4.92086L7.42441 2.76331C7.01652 2.69124 6.62743 2.96348 6.55536 3.37137L3.75643 19.2126C3.68436 19.6205 3.9566 20.0096 4.36449 20.0816L16.5757 22.2392C16.9836 22.3112 17.3726 22.039 17.4447 21.6311L20.2436 5.78992C20.3157 5.38202 20.0435 4.99293 19.6356 4.92086Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11438 6.10547L16.8938 7.47984"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3744 10.4359L8.59406 9.0625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9644 12.7028L8.07471 12.0156"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ReadCv;
